import { render, staticRenderFns } from "./EditionsHistory.vue?vue&type=template&id=ed223468&"
import script from "./EditionsHistory.vue?vue&type=script&lang=js&"
export * from "./EditionsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports